module.exports = __webpack_public_path__ + "img/logo-sm.88fe8ac5.svg";